import { useState } from 'react';
import { platformLogin, PlatformApiError, type PlatformUser } from './api';

// Fase 25B: login de PLATAFORMA. Mismo lenguaje visual del login tenant (24B) pero identidad clara de
// "Administración de plataforma". No se anuncia desde el login tenant; se llega por ruta directa.
export function PlatformLoginPage({ onLoggedIn }: { onLoggedIn: (u: PlatformUser) => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string>();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy || !email.trim() || !password) return;
    setBusy(true); setError(undefined);
    try {
      const { user } = await platformLogin(email.trim(), password);
      setPassword('');
      onLoggedIn(user);
    } catch (err) {
      const msg = err instanceof PlatformApiError ? (err.status === 429 ? err.message : 'Credenciales inválidas.') : 'No fue posible iniciar sesión.';
      setError(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="platform-login">
      <form className="platform-login__card" onSubmit={submit}>
        <div className="platform-login__brand">
          <span className="platform-login__name">Negocio360</span>
          <span className="platform-login__tag">Administración de plataforma</span>
        </div>
        {error && <div className="alert alert--error" role="alert">{error}</div>}
        <label className="field"><span>Correo</span>
          <input type="email" value={email} autoComplete="username" onChange={(e) => setEmail(e.target.value)} autoFocus />
        </label>
        <label className="field"><span>Contraseña</span>
          <input type="password" value={password} autoComplete="current-password" onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button className="button button--primary" disabled={busy || !email.trim() || !password} type="submit">
          {busy ? 'Ingresando…' : 'Ingresar'}
        </button>
      </form>
    </div>
  );
}
